import { Flex } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import NewSend from "~/components/Icons/NewSend";
import { useAppeals, useSetAppeal } from "~/entity/Appeals";
import { IAppealSendCommentParams } from "~/entity/Appeals/model/schema";
import { useSetLocationData } from "~/hooks/locationData";
import { useURLParamsGetter } from "~/hooks/useURLParamsSetter";
import Modal from "~/shared/ui/Fields/Modal";
import RedesignButton from "~/shared/ui/Fields/RedesignButton";
import { TAppealFilter } from "~/entity/Appeals/model/schema";
import { FormGen } from "~/widgets/FormGen";
import { getFormConfigToCommentAppeal } from "~/widgets/Modals/AppealComment/model/config";
import s from "./AppealComment.less";

interface IAppealCommentProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export const AppealComment = ({
  isOpen: isOpenProp,
  onClose: onCloseProp,
}: IAppealCommentProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { setAppealNeedInfo } = useSetAppeal();
  const { queryKeys } = useAppeals();

  const { openModal, currentId, ...settedFilter } = useURLParamsGetter<
    TAppealFilter & { openModal: string; currentId: string }
  >();
  const setData = useSetLocationData();

  const isOpen = isOpenProp ?? openModal === "addComment";
  const handleClose = onCloseProp ?? (() => setData("openModal", ""));

  const configToResolve = getFormConfigToCommentAppeal({
    translateFunc: t,
  });

  const handleSubmit = (data: IAppealSendCommentParams) => {
    if (!currentId) return;

    setAppealNeedInfo.mutate(
      { id: currentId, comment: data.comment },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(queryKeys.all(settedFilter));
          handleClose();
        },
      }
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      title={"Запросить дополнительную информацию"}
      actionClose={handleClose}
      customClassName={s.appealFilesModal}
    >
      <Flex vertical gap={24} style={{ width: "100%" }} align={"start"}>
        <FormGen<IAppealSendCommentParams>
          config={configToResolve}
          defaultValues={{ comment: "" }}
          onSubmit={handleSubmit}
          submitSlot={({ onDefaultReset }) => (
            <Flex gap={8}>
              <RedesignButton
                theme="main"
                txtBtn={"Отмена"}
                onClick={() => {
                  onDefaultReset();
                  handleClose();
                }}
              />
              <RedesignButton
                theme="accent"
                isForm
                txtBtn={"Отправить"}
                iconComponent={<NewSend />}
              />
            </Flex>
          )}
        />
      </Flex>
    </Modal>
  );
};
